import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const carouselCardsSettingsFn = /* @__PURE__ */ createRecipe('carousel-cards-settings', {}, [])

const carouselCardsSettingsVariantMap = {}

const carouselCardsSettingsVariantKeys = Object.keys(carouselCardsSettingsVariantMap)

export const carouselCardsSettings = /* @__PURE__ */ Object.assign(memo(carouselCardsSettingsFn.recipeFn), {
  __recipe__: true,
  __name__: 'carouselCardsSettings',
  __getCompoundVariantCss__: carouselCardsSettingsFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: carouselCardsSettingsVariantKeys,
  variantMap: carouselCardsSettingsVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, carouselCardsSettingsVariantKeys)
  },
  getVariantProps: carouselCardsSettingsFn.getVariantProps,
})